import React, { useState, useEffect } from "react";
import searchIcon from "src/assets/i_search.svg";
import Sidebar from "src/components/layout/Sidebar";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "src/store/store";
import { setCategories, setSectors, setCorps, transformApiData, setSummaries, setRecommend } from "src/store/mainStore";
import { getSummary } from "src/api/MainApi";
import { setServiceType } from "src/store/sessionStore";
import AddHomeModal from 'src/components/modal/AddHomeModal';



const Header: React.FC = () => {
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    
    const toggleSide = () => {
        setIsOpen((prev) => !prev);
    }
    const handleClick = ( service_type ) => {
        dispatch(setServiceType(service_type))
    };
    const serviceType = useSelector((state: RootState) => state.session.serviceType);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getSummary(serviceType);
                const data = response.data;
                const transformedData = transformApiData(data);
                    
                const modifiedSectors = [{ id: null, name: "전체", cnt: 1 }, ...transformedData.sectors.filter(item => item.cnt !== 0)];
                const modifiedCategories = [{ id: null, name: "전체", cnt: 1 },{ id: 0, name: "급상승", cnt: 1 }, ...transformedData.categories.filter(item => item.cnt !== 0)];
                const modifiedCorps = [{ id: null, name: "전체", cnt: 1 }, ...transformedData.corps.filter(item => item.cnt !== 0)];


                // 오늘의 텔레모아 정보
                let summaries = data.summaries || [];
                let recommend = data.recommend || [];
                
                const today = summaries[0];
                summaries = {
                    weather: today?.weather || 0,
                    view_cnt: today?.view_cnt || 0,
                    message_cnt: today?.message_cnt || 0,
                    subscribe_cnt: today.subscribe_cnt || 0,    
                };
                
                dispatch(setSectors(modifiedSectors));
                dispatch(setCategories(modifiedCategories));
                dispatch(setCorps(modifiedCorps));
                dispatch(setSummaries(summaries));
                dispatch(setRecommend(recommend));
            } catch (error) {
                console.error("API 호출 실패:", error);
            }
        };
        fetchData();
        
    }, [serviceType]);
    
    return (
        <header>
            <AddHomeModal />
            <div className="container my-3">
                <div className="navbar navbar-expand-lg d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-4 my-1">
                        <div className="logo">
                            <Link to="/">
                                <h1 className="fw-bold">텔레모아</h1>
                            </Link>
                        </div>
                        {['/stock', '/securitiescompany', '/report', '/blog', '/search'].includes(location.pathname) ? null :
                        <div className="btn-group">
                            <button className={`btn btn-outline-dark ${serviceType === "ST" ? "active" : ""}`} onClick={() => handleClick("ST")}>주식</button>
                            <button className={`btn btn-outline-dark ${serviceType === "CO" ? "active" : ""}`} onClick={() => handleClick("CO")}>코인</button>
                        </div>
                        }
                    </div>

                    <div className="d-flex align-items-center justify-content-end gap-2 my-1">
                        <Link to="/search" className="btn">
                            <i>
                                <img src={searchIcon} alt="검색" />
                            </i>
                        </Link>

                        <button className="navbar-toggler" onClick={toggleSide}>
                        ☰
                        </button>

                        <Sidebar isOpen={isOpen} toggleSide={toggleSide} />
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
